import {
    Flex,
    Input,
    Text,
    useToast
} from '@chakra-ui/react'
import { deleteDoc, doc } from 'firebase/firestore'

import React, { useState } from 'react'
import useApp from '../context/AppContext'
import db from '../firebase'

function SoldPlayer() {
    
    const {soldPlayers, players} = useApp()
    const toast = useToast()
    // const [edit, setEdit] = useState(null)
    const [search, setSearch] = useState("")


    const deleteAuction = async (key) => {

        toast({
            position: 'bottom-right',
            title: `Deleting Auction`,
            // status: `success`,
            duration: 1000,
            isClosable: true,
        })

        await deleteDoc(doc(db, 'soldplayers', key))

        toast({
            position: 'bottom-right',
            title: `Deleted`,
            status: `success`,
            duration: 1000,
            isClosable: true,
        })

    }

    return (
        <Flex
            direction={'column'}
            gap={4}
            w={'full'}
            px={5}
            pt={5}
        >

            {/* {edit?
            <Flex>
            </Flex>
            :
            <>
            </>
            } */}

            <Input
                type={'text'}
                maxW={'70%'}
                m={'auto'}
                placeholder="Search Player"
                value={search}
                onChange={e => setSearch(e.target.value)}
            />

            <Text textAlign={'center'}>Total Players: {soldPlayers?.length || 0}</Text>

            {soldPlayers?.map(s => {

                let player;
                if(search.length > 0)
                    player = players?.players[s.pid]?.name.toLowerCase().includes(search.toLowerCase())
                else
                    player = players?.players[s.pid]

                return (
                    <Flex
                    height={50}
                    alignItems={'center'}
                    px={5}
                    
                    border='1px' 
                    borderColor='gray.700'
                    borderRadius={10}
                    justifyContent={'space-between'}
                    transition={'all 0.25s ease'}
                    _hover= {{
                        color: 'cyan.500',
                        borderColor: 'cyan.500',
                        transform: 'translateY(-3px)'
                    }}
                    role={'group'}
                    >
                        {player.mid}. {player.name}
                    <Flex
                        gap={2}
                    >
                    {/* <Text 
                        bg={'cyan.700'}
                        px={2}
                        py={1}
                        borderRadius={10}
                        color={'white'}
                        display={'none'}
                        _groupHover={{
                            display:"flex"
                        }}
                        cursor={"pointer"}
                        onClick={() => setEdit(player)}
                    >Edit</Text> */}
                    <Text 
                        bg={'red.700'}
                        px={2}
                        py={1}
                        borderRadius={10}
                        color={'white'}
                        display={'none'}
                        _groupHover={{
                            display:"flex"
                        }}
                        cursor={"pointer"}
                        onClick={() => deleteAuction(s.aid)}
                    >Delete</Text>
                    </Flex>

                    </Flex>
                )
            })}

        </Flex>
    )
}

export default SoldPlayer